<template>
  <div>
    <div
      class="
        background-color-white
        border-bottom
        d-flex
        fixed
        full-width
        justify-space-between
        pt-4
        pb-3
        px-3
        z-index-7
      "
    >
      <div class="align-center d-flex" @click="$router.go(-1)">
        <v-icon color="primary">mdi-chevron-left</v-icon>
      </div>
      <v-text-field
        autocomplete="off"
        class="px-3 search-box-radius"
        background-color="#ffffff"
        hide-details="true"
        type="search"
        label="Search for products"
        :value="searchText"
        @input="updateSearchText"
        autofocus
        outlined
        dense
      ></v-text-field>
      <div class="align-center d-flex justify-center">
        <div class="position-relative">
          <Badge />
          <XsCartButton />
        </div>
      </div>
    </div>
    <XsSearchResults />
  </div>
</template>

<script>
import { mapState } from "vuex";
import debounce from "lodash.debounce";
import Badge from "@/components/UI/Badge.vue";
// import SearchResults from "@/components/Search/SearchResults.vue";
// import SearchResults from "@/components/SearchResults/index.vue";
import XsCartButton from "@/components/Auth/Buttons/Xs/Cart.vue";
import XsSearchResults from "@/components/Search/Results/Xs/index.vue";

export default {
  name: "SearchView",
  components: { Badge, XsCartButton, XsSearchResults },
  computed: {
    ...mapState({
      searchText: (state) => state.search.text,
    }),
  },
  data() {
    return {
      typing: false,
    };
  },
  methods: {
    updateSearchText(searchText) {
      this.typing = true;
      this.$store.commit("search/UPDATE_TEXT", searchText);
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    this.scrollToTop();
  },
  watch: {
    searchText: debounce(function () {
      this.typing = false;
    }, 1000),
    typing: async function () {
      this.$store.commit("search/CLEAR_PRODUCTS");
      if (!this.typing && this.searchText.length > 2) {
        await this.$store.dispatch("search/fetch");
      }
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 2px solid #dadada;
}

.fixed {
  position: fixed;
  top: 0;
}

.search-box-radius {
  border-radius: 10px;
}

.z-index-7 {
  z-index: 7;
}
</style>
